import React from 'react'
import PreviewCreated from './PreviewCreated/PreviewCreated'
import PreviewUpdated from './PreviewUpdated/PreviewUpdated'
import PreviewSentEmail from './Modules/User/SentEmail'
import UserInfo from './Modules/User/UserInfo'
import TextValue from '../../../text/TextValue'
import PreviewSync from './PreviewSync/PreviewSync'
import TableCompareImport from './TableCompareImport/TableCompareImport'
import MarkingClass from './Modules/MarkingClass/MarkingClass'
import PreviewBulkSentEmail from './Modules/User/BulkSentEmail'
import MarkingPeriodicalReport from './Modules/PeriodicalReport/MarkingPeriodicalReport'
import TemplateInfo from './Modules/DataEntryTemplate/TemplateInfo'
import AssessmentInfo from './Modules/DataEntryAssessment/AssessmentInfo'
import SurveyInfo from './Modules/DataEntrySurvey/SurveyInfo'
import ImportedTemplates from './Modules/DataEntryTemplate/ImportedTemplates'
import ExportedTemplates from './Modules/DataEntryTemplate/ExportedTemplates'
import { Typography } from '@mui/material'
import TableCompareUpsert from './TableCompareUpsert/TableCompareUpsert'

const DetailAction = ({ form }) => {
  const modules = [
    'user',
    'custom role',
    'tenant',
    'license',
    'roles',
    'board', // MF-554
    'learning continuum',
    'subject',
    'developmental rubric',
    'class',
    'evidence of learning',
    'growth goal',
    'growth goals',
    'photo management',
    'periodical report level',
    'periodical report',
    'periodical report assessment area',
    'periodical report assessment area level',
    'periodical report period',
    'periodical report setting',
    'periodical report marking',
    'periodical report classes',
    'periodical report generator',
    'note of progress',
    'note'
  ]

  if (
    modules.includes(form.module) ||
    form.module.indexOf('setting') > -1 ||
    form.module.indexOf('curriculum') > -1
  ) {
    const actions = [
      'created',
      'created many',
      'created from clone',
      'deleted',
      'archived',
      'archivated',
      'removed',
      'migrate',
      'uploaded',
      'structure added',
      'structure deleted',
      'created worked examples',
      'deleted worked examples',
      'created growth goals',
      'deleted growth goals',
      'created granular steps',
      'deleted granular steps',
      'created worked examples for granular step',
      'deleted worked examples for granular step',
      'added assessment area',
      'deleted assessment area',
      'hard delete'
    ]
    if (actions.includes(form.action)) {
      return <PreviewCreated detail={form.detail} moduleName={form.module} action={form.action} />
    }
    if (
      form.action.indexOf('updated') > -1 ||
      [
        'added students',
        'added teachers',
        'removed students',
        'removed teachers',
        'linked',
        'unlinked'
      ].includes(form.action)
    ) {
      return <PreviewUpdated form={form} />
    }
    if (['sync seeder', 'sync new field'].includes(form.action)) {
      return <PreviewSync detail={form.detail} moduleName={form.module} />
    }
  }
  if (form.module === 'marking') {
    return <MarkingClass detail={form.detail} action={form.action} />
  }

  if (['import', 'export', 'sync maintenance', 'disable maintenance'].includes(form.action)) {
    if (['data-entry survey template', 'data-entry assessment template'].includes(form.module)) {
      return form.action === 'import' ? (
        <ImportedTemplates detail={form.detail} />
      ) : (
        <ExportedTemplates detail={form.detail} />
      )
    }
    return (
      <TableCompareImport
        data={form?.detail?.data || []}
        type={`${form.module} ${form?.detail?.userType || ''}`}
      />
    )
  }

  if (['upsert'].includes(form.action)) {
    return <TableCompareUpsert data={form?.detail?.data || []} />
  }
  if (['sent invitation', 'recovery password'].includes(form.action)) {
    return <PreviewSentEmail detail={form.detail} />
  }
  if (['bulk sent invitation', 'bulk recovery password'].includes(form.action)) {
    return <PreviewBulkSentEmail detail={form.detail} />
  }

  if (form.module === 'periodical report' && ['marking', 'sync marking'].includes(form.action)) {
    return <MarkingPeriodicalReport detail={form.detail} />
  }

  if (form?.detail?.impersonate) {
    return (
      <TextValue
        title='Logged by'
        classNameValue='text-left'
        value={<UserInfo user={form?.detail?.impersonate} />}
      />
    )
  }

  if (
    ['created', 'deleted'].includes(form?.action) &&
    ['data-entry survey template', 'data-entry assessment template'].includes(form?.module)
  ) {
    const isAssessment = form?.module === 'data-entry assessment template'
    return (
      <TemplateInfo
        detail={form.detail}
        moduleName={form.module}
        action={form.action}
        isAssessment={isAssessment}
      />
    )
  }

  if (
    ['updated'].includes(form?.action) &&
    [
      'data-entry survey template',
      'data-entry assessment template',
      'data-entry survey',
      'data-entry assessment',
      'data-entry my surveys',
      'data-entry assessment marking'
    ].includes(form?.module)
  ) {
    return <PreviewUpdated form={form} />
  }

  if (['created', 'deleted'].includes(form?.action) && form?.module === 'data-entry assessment') {
    return <AssessmentInfo form={form} detail={form.detail} />
  }

  if (['created', 'deleted'].includes(form?.action) && form?.module === 'data-entry survey') {
    return <SurveyInfo form={form} detail={form.detail} />
  }
  if (['merged user data'].includes(form?.action) && form?.module === 'user') {
    return (
      <div>
        <Typography variant='subtitle1' className='text-center text-primary pb-2'>
          <div>{form?.detail?.userTarget ? form?.detail?.userTarget?.code : form?.detail?.userTargetId} </div>
        </Typography>
        <div className='flex gap-2 mb-4 items-center justify-center'>
          <div>{form?.detail?.userSource ? form?.detail?.userSource?._id : form?.detail?.userSourceId} </div>
          <div className='text-center'> &#8594; </div>
          <div>{form?.detail?.userTarget ? form?.detail?.userTarget?._id : form?.detail?.userTargetId} </div>
        </div>

        {form?.detail?.messages && form?.detail?.messages.length > 0 ? (
          <div>
            {form?.detail?.messages.map((item, index) => (
              <div key={index} style={{ marginBottom: '6px' }}>
                <Typography variant='body' gutterBottom>
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </Typography>
              </div>
            ))}
          </div>
        ) : (
          <div>No data available.</div>
        )}
      </div>
    )
  }

  if (['sync data'].includes(form?.action) && form?.module === 'tenant') {
    return (
      <div>
        <Typography variant='subtitle1' className='text-center text-primary pb-2'>
          Synced Data{' '}
        </Typography>
        {form?.detail?.result && form?.detail?.result.length > 0 ? (
          <div>
            {form?.detail?.result.map((item, index) => (
              <div key={index} style={{ marginBottom: '16px' }}>
                <Typography variant='body' gutterBottom>
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </Typography>
              </div>
            ))}
          </div>
        ) : (
          <div>No data available.</div>
        )}
      </div>
    )
  }

  return <pre>{JSON.stringify(form, null, 2)}</pre>
}
export default DetailAction
